export default "__VITE_ASSET__ba30e9c4__"